import { FaBuilding, FaUser, FaUserTie } from "react-icons/fa";
import NTlogo from "../public/assets/img/NTLogo.png";
import ApplicationProcess from "../public/assets/img/application-process.png";
import RevocationProcess from "../public/assets/img/revocation-process.png";
import Ntca1 from "../public/assets/img/ntca/ntca-1.png";
import Ntca2 from "../public/assets/img/ntca/ntca-2.png";
import Ntca3 from "../public/assets/img/ntca/ntca-3.png";
import Cert1 from "../public/assets/img/cert-01.png";
import Cert2 from "../public/assets/img/cert-02.png";
import Cert3 from "../public/assets/img/cert-03.png";

const certificateTypes = [
  {
    title: "บุคคลธรรมดา",
    englishTitle: "Person Certificate",
    description:
      "สำหรับบุคคลทั่วไป ที่ต้องการยืนยันตัวตนในการลงลายมือชื่อดิจิทัล และเพิ่มความน่าเชื่อถือให้กับเอกสารอิเล็กทรอนิกส์",
    Icon: FaUser,
  },
  {
    title: "นิติบุคคล",
    englishTitle: "Juristic Person Certificate",
    description:
      "สำหรับนิติบุคคล ที่ต้องการยืนยันตัวตนในการลงลายมือชื่อดิจิทัล และเพิ่มความน่าเชื่อถือให้กับเอกสารอิเล็กทรอนิกส์",
    Icon: FaBuilding,
  },
  {
    title: "เจ้าหน้าที่นิติบุคคล",
    englishTitle: "Enterprise User Certificate",
    description:
      "สำหรับเจ้าหน้าที่นิติบุคคล ที่ต้องการยืนยันตัวตนในการลงลายมือชื่อดิจิทัล และเพิ่มความน่าเชื่อถือให้กับเอกสารอิเล็กทรอนิกส์",
    Icon: FaUserTie,
  },
];

const trustSeals = [
  {
    href: "https://www.cpacanada.ca/webtrustseal?sealid=11951",
    src: Cert1,
    alt: "WebTrust Seal 11951",
  },
  {
    href: "https://www.cpacanada.ca/webtrustseal?sealid=11953",
    src: Cert2,
    alt: "WebTrust Seal 11953",
  },
  {
    href: "https://www.cpacanada.ca/webtrustseal?sealid=11952",
    src: Cert3,
    alt: "WebTrust Seal 11952",
  },
];

export default function Home() {
  return (
    <main className="overflow-hidden bg-white text-slate-900">
      <section
        id="ntca-home"
        className="flex min-h-[540px] items-center bg-gradient-to-br from-[#ffcf33] via-[#ffc107] to-[#f3a900] px-6 py-20"
      >
        <div className="mx-auto w-full max-w-5xl text-center">
          <img
            src={NTlogo}
            width="130"
            height="90"
            alt="NT CA"
            className="mx-auto mb-6 h-auto w-28"
          />
          <h1 className="text-3xl font-bold leading-tight md:text-5xl">
            NT CA (Subordinate NRCA)
          </h1>
          <p className="mx-auto mt-6 max-w-4xl text-lg leading-8 md:text-2xl md:leading-10">
            ผู้ให้บริการออกใบรับรองอิเล็กทรอนิกส์ (Certification Authority: CA)
            ภายใต้ บริษัท โทรคมนาคมแห่งชาติ จำกัด (มหาชน)
            เพื่อรองรับการยืนยันตัวตนทางดิจิทัล การลงลายมือชื่อดิจิทัล
            และการสร้างความน่าเชื่อถือให้กับเอกสารและธุรกรรมอิเล็กทรอนิกส์
            สำหรับหน่วยงานภาครัฐ ภาคเอกชน และประชาชน
          </p>
        </div>
      </section>

      <section id="ntca-service" className="px-6 py-20">
        <div className="relative mx-auto max-w-6xl overflow-hidden rounded-3xl bg-gradient-to-br from-slate-950 via-slate-900 to-amber-950 px-6 py-16 text-white shadow-xl md:px-14 md:py-24">
          <div
            aria-hidden="true"
            className="absolute -right-24 -top-24 h-80 w-80 rounded-full border-[48px] border-amber-400/10"
          />
          <div
            aria-hidden="true"
            className="absolute -bottom-32 right-1/4 h-72 w-72 rounded-full bg-amber-300/5"
          />
          <div className="relative max-w-4xl">
            <h2 className="text-3xl font-bold text-[#ffd23f] md:text-5xl">
              บริการ NT CA (Subordinate NRCA)
            </h2>
            <p className="mt-7 text-lg leading-9 md:text-2xl md:leading-10">
              ผู้ให้บริการออกใบรับรองอิเล็กทรอนิกส์
              ที่ได้รับการรับรองในการเข้าร่วมเป็น Subordinate ของ Thailand NRCA
              และผ่านการรับรองมาตรฐาน WebTrust Seal
              ซึ่งเป็นเครื่องหมายรับรองที่ได้รับการยอมรับในระดับสากล
            </p>
          </div>
        </div>
      </section>

      <section id="certificate-types" className="bg-slate-50 px-6 py-20">
        <div className="mx-auto max-w-6xl">
          <h2 className="mx-auto max-w-4xl text-center text-3xl font-bold leading-tight md:text-4xl">
            ประเภทใบรับรองอิเล็กทรอนิกส์ของ บริการ NT CA (Subordinate NRCA)
          </h2>
          <div className="mt-12 grid gap-6 md:grid-cols-3">
            {certificateTypes.map(
              ({ title, englishTitle, description, Icon }) => (
                <article
                  key={englishTitle}
                  className="flex h-full flex-col overflow-hidden rounded-2xl border border-amber-200 bg-white shadow-md"
                >
                  <div className="bg-[#ffc107] px-5 py-5 text-center">
                    <h3 className="text-2xl font-bold">{title}</h3>
                    <p className="mt-1 text-lg">({englishTitle})</p>
                  </div>
                  <div className="flex flex-1 flex-col items-center px-6 py-8">
                    <div className="flex h-28 w-28 items-center justify-center rounded-full bg-amber-100 text-5xl text-amber-600">
                      <Icon aria-hidden="true" />
                    </div>
                    <p className="mt-7 text-lg leading-8">{description}</p>
                  </div>
                </article>
              ),
            )}
          </div>
          <p className="mt-8 rounded-xl bg-slate-200 px-6 py-5 text-center text-xl font-semibold md:text-2xl">
            อายุการใช้บริการ : 3 เดือน&nbsp; : 1 ปี&nbsp; : 2 ปี&nbsp; : 3 ปี
          </p>
        </div>
      </section>

      <section id="service-processes" className="px-6 py-20">
        <div className="mx-auto max-w-6xl space-y-16">
          <figure>
            <figcaption className="mb-7 text-center text-amber-500">
              <h2 className="text-3xl font-bold md:text-4xl">
                ขั้นตอนการสมัครขอใช้บริการ
              </h2>
            </figcaption>
            <img
              src={ApplicationProcess}
              alt="แผนภาพขั้นตอนการสมัครขอใช้บริการ NT CA จำนวน 6 ขั้นตอน"
              className="mx-auto h-auto w-full rounded-2xl shadow-lg"
            />
          </figure>
          <figure>
            <figcaption className="mb-7 text-center text-amber-500">
              <h2 className="text-3xl font-bold md:text-4xl">
                ขั้นตอนการเพิกถอนใบรับรองฯ
              </h2>
            </figcaption>
            <img
              src={RevocationProcess}
              alt="แผนภาพขั้นตอนการเพิกถอนใบรับรอง NT CA จำนวน 5 ขั้นตอน"
              className="mx-auto h-auto w-full rounded-2xl shadow-lg"
            />
          </figure>
        </div>
      </section>

      <section id="ntca-certifications" className="bg-slate-50 px-6 py-20">
        <div className="mx-auto max-w-6xl">
          <h2 className="text-center text-3xl font-bold text-amber-500 md:text-4xl">
            มาตรฐานและการรับรอง NT CA
          </h2>
          <div className="mt-10 flex flex-wrap items-end justify-center gap-5 md:gap-8">
            {trustSeals.map(({ href, src, alt }) => (
              <a
                key={href}
                href={href}
                target="_blank"
                className="rounded-lg focus:outline-none focus:ring-4 focus:ring-amber-300"
                aria-label={`${alt} (เปิดในแท็บใหม่)`}
              >
                <img src={src} alt={alt} className="h-auto w-32 md:w-36" />
              </a>
            ))}
            <img src={Ntca1} alt="การรับรอง NT CA 1" className="h-auto w-32" />
            <img src={Ntca2} alt="การรับรอง NT CA 2" className="h-auto w-28" />
            <img src={Ntca3} alt="การรับรอง NT CA 3" className="h-auto w-32" />
          </div>
        </div>
      </section>
    </main>
  );
}
